<template>
  <el-dialog
        title="修改管理员"
        :visible.sync="editDialogVisible"
        width="50%"
        @close="editDialogClosed"
        >
          <el-form
          ref="editFormRef" label-width="90px" :model="editForm" :rules="rules">
              <el-form-item label="账号名" prop="username">
                  <el-input v-model="editForm.username"></el-input>
              </el-form-item>
              <el-form-item label="姓名" prop="realName">
                  <el-input v-model="editForm.realName"></el-input>
              </el-form-item>
          </el-form>
          <!-- 底部区域 -->
          <span slot="footer" class="dialog-footer">
              <el-button @click="editDialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="editUser">确 定</el-button>
          </span>
        </el-dialog>
</template>

<script>
export default {
     data() {
      // 验证真实姓名的规则
      // var checkRealname = (rules, value, cr) => {
      //   // 验证真实姓名的正则表达式
      //   const realnameReg = /^[\u4E00-\u9FA5]{2,10}(·[\u4E00-\u9FA5]{2,10}){0,2}$/
      //   if (realnameReg.test(value)) {
      //     return cr()
      //   }
      //   cr(new Error('请输入真实姓名'))
      // }
      return {
        rules: {
          username: [{ required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 3, max: 10, message: '长度在3 到 10 个字符之间', trigger: 'blur' }],
          realName: [{ required: true, message: '请输入姓名', trigger: 'blur' }]
        },
        editDialogVisible: false,
        editFormId: '',
        editForm: {
          username: '',
          realName: ''
        }
      }
    },
    methods: {
    // 修改弹框被关闭之后
    editDialogClosed () {
      this.$refs.editFormRef.resetFields()
    },
    // 展示修改弹框
    showEditDialog (id) {
      this.editFormId = id
      this.editDialogVisible = true
      this.$requestBase({
        url: `v1/platform/admin/findPlatformById/${id}`,
        method: 'GET'
      }).then(res => {
        this.$message.success('获取平台管理员成功！')
        this.editForm.id = id
        this.editForm.username = res.data.username
        this.editForm.realName = res.data.realName
      })
    },
    // 修改用户
    editUser () {
      this.$refs.editFormRef.validate(valid => {
        if (!valid) return
      this.$requestBase({
        url: 'v1/platform/admin/update',
        method: 'POST',
        data: this.editForm
      }).then(res => {
        this.editDialogVisible = false
        this.$message.success('修改平台管理员成功！')
        this.$parent.getPlatformAdminList()
      })
      })
    },
    // 外部调用
    show(id) {
      this.showEditDialog(id)
    }
    }
}
</script>

<style>

</style>
